import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialCommitteeState: Dtos.Committee & IRegistrationFormState = {
    id: null,
    name: null,
    rank: null,
    adminOnly: null,
    tmdAdminCanEdit: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ICommitteeReduxFormState {
    id: IFieldState<number>
    name: IFieldState<string>
    rank: IFieldState<number>
    adminOnly: IFieldState<boolean>
    tmdAdminCanEdit: IFieldState<boolean>
    active: IFieldState<boolean>
    dateEntered: IFieldState<string>
    dateModified: IFieldState<string>
    enteredBy: IFieldState<string>
    modifiedBy: IFieldState<string>
}
